import { WidgetConfigWithHideableToolbar } from 'widgets/WidgetToolbarShowHidePanel/WidgetConfigWithHideableToolbar';
import { WidgetId } from 'widgets/WidgetId';
import { WidgetConfigWithTabTitle } from 'widgets/tabTitle/WidgetConfigWithTabTitle';

export type TilesOrientation = 'row' | 'column';

export interface CapsuleContainerWidgetConfigState
    extends WidgetConfigWithHideableToolbar,
        WidgetConfigWithTabTitle {
    orientation: TilesOrientation;
    tiles: WidgetId[];
    symbol?: string;
}

export const initialTilesConfigState: CapsuleContainerWidgetConfigState = {
    orientation: 'row',
    hideToolbar: false,
    tiles: [],
};
